// extracted by mini-css-extract-plugin
export default {"page":"JZ-z","cartModal":"KZ-z","checkout":"LZ-z","placeholder":"MZ-z","account":"NZ-z"};